import { TextButton as StyledTextButton } from './TextButton.styles';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import React from 'react';

export interface TextButtonProps {
  /**
   * Text link contents.
   */
  label: string;
  /**
   * Corresponds to font size.
   */
  size?: 'medium' | 'small' | 'tiny';
  /**
   * Corresponds to font weight.
   */
  weight?: 'light' | 'regular';
  /**
   * If true, uses styles for 'I'm not sure' text buttons in OPR question flow.
   */
  notSureButton?: boolean;
  /**
   * If true, right arrow will be displayed to the right of the button text.
   */
  rightArrow?: boolean;
  /**
   * If true, left arrow will be displayed to the left of the button text.
   */
  leftArrow?: boolean;
  /**
   * If true, text color will be grey
   */
  grey?: boolean;
  /**
   * If true, text will be underlined
   */
  underlinedText?: boolean;
  /**
   * Optional click handler.
   */
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  /**
   * id used for testing
   */
  'data-testid'?: string;
}

/**
 * Navigation text links.
 */
export const TextButton: React.FC<TextButtonProps> = ({
  label,
  size = 'small',
  notSureButton = false,
  rightArrow = false,
  leftArrow = false,
  weight = 'light',
  grey = false,
  underlinedText = false,
  ...props
}: TextButtonProps) => {
  return (
    <StyledTextButton
      size={size}
      notSureButton={notSureButton}
      grey={grey}
      weight={weight}
      underlinedText={underlinedText}
      {...props}
    >
      {leftArrow && <KeyboardArrowLeft />}
      {label}
      {rightArrow && <KeyboardArrowRight />}
    </StyledTextButton>
  );
};

export default TextButton;
